import { keepPreviousData } from '@tanstack/react-query'

type PreviousQuery = { queryKey: readonly unknown[] }

function withoutPage(params: unknown): string {
  if (params === null || typeof params !== 'object') return JSON.stringify(params ?? null)
  const { page: _page, ...rest } = params as Record<string, unknown>
  void _page
  return JSON.stringify(rest, Object.keys(rest).sort())
}

/**
 * `placeholderData` dla list stronicowanych: podczas zmiany strony zostaje poprzednia
 * (licznik i pager nie mrugają, a clamp nie widzi „pustej” listy), ale zmiana filtra
 * nie pokazuje starych wierszy pod nowym filtrem. Klucz orvala to `[url, params]`.
 */
export function keepPreviousPage<T>(currentParams: unknown) {
  return (previous: T | undefined, previousQuery?: PreviousQuery): T | undefined => {
    if (previousQuery === undefined) return undefined
    return withoutPage(previousQuery.queryKey[1]) === withoutPage(currentParams)
      ? keepPreviousData(previous)
      : undefined
  }
}
